import React from 'react';
import './sidebar.scss';
import { NavLink } from 'react-router-dom';
import linkfluencer from '../../../assets/images/linkfluencer.png';
import dashboard from '../../../assets/home.svg';
import aiBrain from '../../../assets/ai-brain.svg';
import crm from '../../../assets/crm.svg';
import calendar from '../../../assets/calendar.svg';
import support from '../../../assets/headset.svg';
import reporting from '../../../assets/reporting.svg';

function SideBar() {
  const onHelpClick = () => {
    window.open('https://support.linkfluencer.com/hc/en-us', '_blank');
  };
  return (
    <div>
      <div className="">
        <NavLink className="dashboard-logo" to="/dashboard" replace>
          <img alt="Linkfluencer" src={linkfluencer} />
        </NavLink>
      </div>
      <div className="menu-bar">
        <div className="menu">
          <NavLink className="menu-item menu-link" to="/dashboard" replace>
            <img alt="home" src={dashboard} /> <span>Dashboard</span>
          </NavLink>

          <NavLink className="menu-item menu-link" to="/opportunities" replace>
            <img alt="opportunities" src={calendar} /> <span>Opportunities</span>
          </NavLink>

          <NavLink className="menu-item menu-link" to="/crm" replace>
            <img alt="leads" src={crm} /> <span>Leads</span>
          </NavLink>

          <NavLink className="menu-item menu-link" to="/sequence-builder" replace>
            <img alt="sequence-builder" src={reporting} /> <span>Sequence Builder</span>
          </NavLink>

          <NavLink className="menu-item menu-link" to="/ai-strategy" replace>
            <img alt="strategy-builder" src={aiBrain} /> <span>Strategy Builder</span>
          </NavLink>

          <div className="menu-item menu-link" onClick={onHelpClick}>
            <img alt="support" src={support} /> <span>Support</span>
          </div>
        </div>
        <div className="copyright">Copyright 2026. Linkfluencer LLC</div>
      </div>
    </div>
  );
}

export default SideBar;
